import {
  BARCLUB_ADD_REQUEST,
  BARCLUB_ADD_SUCCESS,
  BARCLUB_ADD_FAILURE,
  BARCLUB_EDIT_REQUEST,
  BARCLUB_EDIT_SUCCESS,
  BARCLUB_EDIT_FAILURE,
  BARCLUB_VIEW_REQUEST,
  BARCLUB_VIEW_SUCCESS,
  BARCLUB_VIEW_FAILURE,
  BARCLUB_VIEW_ALL_REQUEST,
  BARCLUB_VIEW_ALL_SUCCESS,
  BARCLUB_VIEW_ALL_FAILURE,
  BARCLUB_DELETE_REQUEST,
  BARCLUB_DELETE_SUCCESS,
  BARCLUB_DELETE_FAILURE,
  BARCLUB_RESET_STATE,
  BARCLUB_SEARCH_REQUEST,
  BARCLUB_SEARCH_SUCCESS,
  BARCLUB_SEARCH_FAILURE,
  BARCLUB_VIEW_ALL_BY_WHOLESALERID_REQUEST,
  BARCLUB_VIEW_ALL_BY_WHOLESALERID_SUCCESS,
  BARCLUB_VIEW_ALL_BY_WHOLESALERID_FAILURE,
  BARCLUB_WHOLESALERID_SEARCH_REQUEST,
  BARCLUB_WHOLESALERID_SEARCH_SUCCESS,
  BARCLUBL_WHOLESALERID_SEARCH_FAILURE,
} from "./BarClubTypes";

// Add Bar/Club Actions
export const barClubAddRequest = (credentials) => ({
  type: BARCLUB_ADD_REQUEST,
  payload: credentials,
});

export const barClubAddSuccess = (data) => ({
  type: BARCLUB_ADD_SUCCESS,
  payload: data,
});

export const barClubAddFailure = (error) => ({
  type: BARCLUB_ADD_FAILURE,
  payload: error,
});

// Edit Bar/Club Actions
export const barClubEditRequest = (id, credentials) => ({
  type: BARCLUB_EDIT_REQUEST,
  payload: { id, credentials },
});

export const barClubEditSuccess = (data) => ({
  type: BARCLUB_EDIT_SUCCESS,
  payload: data,
});

export const barClubEditFailure = (error) => ({
  type: BARCLUB_EDIT_FAILURE,
  payload: error,
});

// View Bar/Club Actions
export const barClubViewRequest = (id) => ({
  type: BARCLUB_VIEW_REQUEST,
  payload: id,
});

export const barClubViewSuccess = (data) => ({
  type: BARCLUB_VIEW_SUCCESS,
  payload: data,
});

export const barClubViewFailure = (error) => ({
  type: BARCLUB_VIEW_FAILURE,
  payload: error,
});

// View All Bars/Clubs Actions
export const barClubViewAllRequest = (payload) => ({
  type: BARCLUB_VIEW_ALL_REQUEST,
  payload,
});

export const barClubViewAllSuccess = (data) => ({
  type: BARCLUB_VIEW_ALL_SUCCESS,
  payload: data,
});

export const barClubViewAllFailure = (error) => ({
  type: BARCLUB_VIEW_ALL_FAILURE,
  payload: error,
});

// View All Search Bar/Club Actions
export const barClubViewSearchViewAllRequest = () => ({
  type: BARCLUB_SEARCH_REQUEST,
});

export const barClubViewSearchViewAllSuccess = (barClub) => ({
  type: BARCLUB_SEARCH_SUCCESS,
  payload: barClub,
});

export const barClubViewSearchViewAllFailure = (error) => ({
  type: BARCLUB_SEARCH_FAILURE,
  payload: error,
});

// View All Bars/Clubs By Wholesaler Id Actions
export const barClubViewAllByWholesalerIdRequest = (wholesalerId, pageNo, search_key) => ({
  type: BARCLUB_VIEW_ALL_BY_WHOLESALERID_REQUEST,
  payload: { wholesalerId, pageNo, search_key },
});

export const barClubViewAllByWholesalerIdSuccess = (data) => ({
  type: BARCLUB_VIEW_ALL_BY_WHOLESALERID_SUCCESS,
  payload: data,
});

export const barClubViewAllByWholesalerIdFailure = (error) => ({
  type: BARCLUB_VIEW_ALL_BY_WHOLESALERID_FAILURE,
  payload: error,
});

// View All Search Bar/Club By Wholesaler Id Actions
export const barClubViewSearchByWholesalerIdViewAllRequest = (
  wholesalerId
) => ({
  type: BARCLUB_WHOLESALERID_SEARCH_REQUEST,
  payload: wholesalerId,
});

export const barClubViewSearchByWholesalerIdViewAllSuccess = (barClub) => ({
  type: BARCLUB_WHOLESALERID_SEARCH_SUCCESS,
  payload: barClub,
});

export const barClubViewSearchByWholesalerIdViewAllFailure = (error) => ({
  type: BARCLUBL_WHOLESALERID_SEARCH_FAILURE,
  payload: error,
});

// Delete Bar/Club Actions
export const barClubDeleteRequest = (id) => ({
  type: BARCLUB_DELETE_REQUEST,
  payload: id,
});

export const barClubDeleteSuccess = (data) => ({
  type: BARCLUB_DELETE_SUCCESS,
  payload: data,
});

export const barClubDeleteFailure = (error) => ({
  type: BARCLUB_DELETE_FAILURE,
  payload: error,
});

// Reset State Action
export const barClubResetState = () => ({
  type: BARCLUB_RESET_STATE,
});
